import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalHeader,
  HStack,
  Text,
} from '@chakra-ui/react';
import { keyframes, css } from '@emotion/react';

type RedirectingModalProps = {
  isOpen: boolean;
};

export default function RedirectingModal({ isOpen }: RedirectingModalProps) {
  const extend = keyframes`
    0%{
      width: 0rem;
    }
    100%{
      width: 3rem;
    }
  `;

  const loadingText = css`
    animation: ${extend} 3s steps(4, end) infinite;
    display: inline-block;
    overflow: hidden;
    vertical-align: bottom;
  `;

  return (
    <Modal size="xs" isOpen={isOpen} onClose={() => {}} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textAlign="center" w="full" pb={0} color="wsBlack">
          金流跳轉中，請稍候
          <HStack css={loadingText} border="1px solid #fff">
            <Text w="2rem" color="wsBlack" textAlign="center" letterSpacing=".2em">
              ...
            </Text>
          </HStack>
        </ModalHeader>
        <ModalBody px={5} pt={2} pb={5}>
          <Text textAlign="center" color="#C8161D">
            請不要關閉現在頁面
          </Text>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
